import React, { useState } from 'react';
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
    Avatar,

} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '640px',
    width: '96%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};


const getInitials = (name) => {
    const words = name.split(' ');
    return words.length > 1
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase()
        : name.slice(0, 2).toUpperCase();
};


const user = {
    name: 'Salona Mishra',
    image: '/assets/images/users/user1.png',
};

const EditWeeklyLimit = ({ open, onClose }) => {
   
    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm" >
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>

                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Edit weekly limit</Typography>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>


                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom:'24px' }}>
                        <Box>
                            <Typography fontWeight="400" sx={{ fontSize: '12px', color: '#606060', fontFamily: 'Manrope' }}>Member</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <Avatar src={user.image} sx={{ fontSize: '14px', background: '#0067C7', fontFamily: 'Manrope' }}>
                                    {!user.image && getInitials(user.name)}
                                </Avatar>
                                <Box>
                                    <Typography fontWeight="bold" sx={{ fontSize: '14px', color: '#373737', fontFamily: 'Manrope' }}>{user.name}</Typography>
                                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#8C8C8C', fontFamily: 'Manrope' }}>
                                        Project Manager
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ m: '0 auto 0' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily: 'Manrope' }}>Recurring weekly limit</Typography>
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '4px' }}>
                            <TextField fullWidth placeholder="Hour per week" variant="outlined" margin="normal"
                                sx={{
                                    marginTop: '0', '& .MuiOutlinedInput-root': {
                                        height: '40px', fontSize: '14px', color: '#64748B', fontFamily: 'Manrope',
                                        '& fieldset': { borderColor: '#D0D5DD', fontFamily: 'Manrope' },
                                    }, '& .MuiInputBase-input': { padding: '10px 18px', fontFamily: 'Manrope' },
                                }} />
                            
                        </Box>
                    </Box>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                        Save
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default EditWeeklyLimit;
